export default __webpack_public_path__ + "static/media/threaded-comments-logo.0ce884fd.svg";